import { render, staticRenderFns } from "./ListDumpsterSizes.vue?vue&type=template&id=4f12a0c6&scoped=true&"
import script from "./ListDumpsterSizes.vue?vue&type=script&lang=js&"
export * from "./ListDumpsterSizes.vue?vue&type=script&lang=js&"
import style0 from "./ListDumpsterSizes.vue?vue&type=style&index=0&id=4f12a0c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12a0c6",
  null
  
)

export default component.exports